import { memo } from 'react'
import GiftAnimation from './GiftAnimation'
import { safeOpenTelegramLink, safeSheetOpenHaptic } from '../lib/safeTelegram'

const ZEUS_MARKET_URL = 'https://t.me/zeus_market_bot?start=patrick'
const VPN_AD_URL = 'https://t.me/PatrickVPNrobot?start=ad_QLg2NYRc'
const BLINK_PAY_AD_URL = 'https://blinkpay.ru/?utm_source=patrick&utm_medium=cpa&utm_campaign=webapp'

function CardArrow({ hero = false }) {
  return (
    <img loading="eager"
      src="/images/icons/figma/direction-right.svg"
      alt=""
      width="24"
      height="24"
      aria-hidden="true"
      className={`absolute right-2 top-2 z-[3] h-6 w-6 ${hero ? 'opacity-100' : 'opacity-50'}`}
    />
  )
}

function HomeActionCard({ title, subtitle, imageSrc, onClick, wide = false, imageVariant = 'default', disableActive = false }) {
  const handleClick = () => {
    safeSheetOpenHaptic()
    onClick?.()
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`home-figma-card relative overflow-hidden rounded-2xl text-left ${disableActive ? '' : 'transition-transform active:scale-[0.98]'} ${
        wide
          ? 'flex h-[82px] w-full items-center gap-3 px-4 py-3'
          : 'flex h-[154px] min-w-0 flex-1 flex-col items-center justify-center gap-3 px-4 py-4 text-center'
      }`}
    >
      <div className={`${wide ? 'h-12 w-12' : 'h-16 w-16'} relative shrink-0`}>
        {imageVariant === 'premium' ? (
          <img loading="eager"
            src={imageSrc}
            alt=""
            className="absolute left-[-13.5px] top-[-31.5px] h-[90.5px] w-[90.5px] max-w-none object-contain"
            decoding="async"
            aria-hidden="true"
          />
        ) : (
          <img loading="eager"
            src={imageSrc}
            alt=""
            className="h-full w-full object-contain"
            decoding="async"
            aria-hidden="true"
          />
        )}
      </div>
      <div className={wide ? 'min-w-0 flex-1 pr-5' : 'w-full text-center'}>
        <p className="text-[20px] font-[510] leading-6 tracking-[-0.02em] text-white">{title}</p>
        <p className={`mt-1 text-[14px] font-[400] leading-4 tracking-[-0.01em] text-white/68 ${wide ? 'truncate' : ''}`}>{subtitle}</p>
      </div>
      <CardArrow />
    </button>
  )
}

function AdBanner({ imageSrc, alt, href, wide = false }) {
  const handleClick = () => {
    safeSheetOpenHaptic()
    safeOpenTelegramLink(href)
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={alt}
      className={`${wide ? 'w-full' : 'min-w-0 flex-1'} overflow-hidden rounded-2xl transition-transform active:scale-[0.98]`}
    >
      <img
        src={imageSrc}
        alt=""
        className="block h-auto w-full"
        loading="eager"
        decoding="async"
      />
    </button>
  )
}

function HomeHub({
  onOpenStars,
  onOpenPremium,
  onOpenRent,
}) {
  return (
    <section className="relative min-h-0 w-full space-y-2" aria-label="Каталог магазина">
      <button
        type="button"
        onClick={() => {
          safeSheetOpenHaptic()
          onOpenStars?.()
        }}
        className="home-figma-card relative flex h-[148px] w-full overflow-hidden rounded-2xl p-4 text-left transition-transform active:scale-[0.98]"
        style={{
          background: '#007CFF',
          borderColor: 'rgba(250, 250, 255, 0.50)',
        }}
      >
        <div className="relative z-[2] flex min-w-0 flex-col justify-between">
          <div className="flex items-center gap-1 whitespace-nowrap text-[24px] font-[510] leading-7 tracking-[-0.02em] text-white">
            <span>Купить</span>
            <img loading="eager" src="/images/icons/figma/stars.svg" alt="" width="24" height="24" className="h-6 w-6 shrink-0" aria-hidden="true" />
            <span>STARS</span>
          </div>
          <p className="text-[14px] font-[400] leading-4 tracking-[-0.01em] text-white/75">Лучший курс на рынке</p>
        </div>
        <CardArrow hero />
        <div className="pointer-events-none absolute left-1/2 top-[-17px] z-[1] h-[182px] w-[182px]" aria-hidden="true">
          <GiftAnimation lottieUrl="/images/lottie/json/buy_stars.json" className="h-full w-full" />
        </div>
      </button>

      <div className="flex w-full gap-2">
        <HomeActionCard
          title="Premium"
          subtitle="Подписка Telegram"
          imageSrc="/images/categories/premium.webp"
          imageVariant="premium"
          onClick={onOpenPremium}
        />
        <HomeActionCard
          title="Аренда"
          subtitle="NFT подарки и др."
          imageSrc="/images/categories/rent.webp"
          onClick={onOpenRent}
        />
      </div>

      <div className="flex w-full gap-2">
        <AdBanner
          imageSrc="/images/banners/ad_vpn.svg"
          alt="Открыть Patrick VPN"
          href={VPN_AD_URL}
        />
        <AdBanner
          imageSrc="/images/banners/ad_market.svg"
          alt="Открыть Zeus Market"
          href={ZEUS_MARKET_URL}
        />
      </div>

      <AdBanner
        imageSrc="/images/banners/ad_steam.svg"
        alt="Открыть Blink Pay"
        href={BLINK_PAY_AD_URL}
        wide
      />

    </section>
  )
}

export default memo(HomeHub)
